export default {"src":"/_next/static/media/aboutUsHeaderIcon.f9185fd9.svg","height":19,"width":24,"blurWidth":0,"blurHeight":0};